var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTimeEnd16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0h4v2H6V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9v3h2V9H7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 9A6 6 0 1 1 2 9a6 6 0 0 1 12 0Zm-6 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTimeEnd16);
export default __webpack_public_path__ + "static/media/ic_action_time_end_16.8b420d082c3efbb24706826601ac8473.svg";
export { ForwardRef as ReactComponent };